<template>
  <div
    v-clickoutside="hidePopover"
    class="lp-tooltip"
    data-ua-unique-id="unique-popover"
  >
    <span ref="trigger" class="lp-tooltip-trigger" @click="showPopover">
      <slot></slot>
    </span>

    <transition :name="transition">
      <div
        v-show="show && !disabled"
        ref="popover"
        class="lp-tooltip-popper"
        :class="[placement && `lp-tooltip-${placement}`]"
      >
        <div
          class="lp-tooltip-content"
          :class="{
            'lp-tooltip-content-borderless': borderless,
          }"
        >
          <slot name="content"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent } from 'vue'
import { usePopover } from '@/hooks'
import { clickOutside } from '@/directives'
import { Positions } from '@/models/enums'

export default defineComponent({
  name: 'lp-popover',
  directives: {
    clickoutside: clickOutside,
  },
  props: {
    disabled: Boolean,
    borderless: Boolean,
    placement: {
      type: String,
      default: Positions.T,
      validator: (value: Positions) =>
        [Positions.B, Positions.L, Positions.R, Positions.T].includes(value),
    },
    autoposition: { type: Boolean, default: true },
  },
  setup(props) {
    const popover = ref(null)
    const trigger = ref(null)

    const {
      show,
      placement,
      disabled,
      clickable,
      transition,
      position,
      hidePopover,
      showPopover,
      setPopoverPosition,
    } = usePopover({
      ...props,
      popover,
      trigger,
      arrowCalculation: false,
    })

    return {
      show,
      placement,
      disabled,
      clickable,
      transition,
      popover,
      trigger,
      position,
      hidePopover,
      showPopover,
      setPopoverPosition,
    }
  },
})
</script>
